import authorityReducer from "@authority/authority-shared/utilities/redux/reducers";

export const reduxReducers = {

  ...authorityReducer,
};